import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../utils/snackbar/snackbar.service';
import { StorageService } from '../storage/storage.service';

@Injectable()
export class SelectedClinicInterceptor implements HttpInterceptor {

  ignoredRoutes: string[] = [
    '/auth',
    '/auth/password/recover',
    '/register',
    '/all/employee',
    '/set',
    '/clinic/all/employee',
  ]

  constructor(
    private storage: StorageService,
    private router: Router,
    private message: SnackbarService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let apiRoute: string = request.url.replace(environment.api, '').split('?')[0]
    if (this.verifyIfRouteIsIgnored(apiRoute)) {
      return next.handle(request)
    }
    let clinicToken: string = this.storage.clinicToken
    if (!clinicToken) {
      this.router.navigate(['select-clinic'])
      this.message.show('Por favor, selecione uma clínica.')
      return EMPTY
    }
    request = request.clone({
      setHeaders: { clinic: clinicToken }
    })
    return next.handle(request);
  }

  private verifyIfRouteIsIgnored(requestPath: string): boolean {
    for (const ignoredRoute of ['/auth', '/register']) {
      if (requestPath.startsWith(ignoredRoute)) {
        return true
      }
    }
    return false
  }
}